module.exports = __webpack_public_path__ + "static/media/tasklevel3_open.eb5b83cc.png";